import moment from 'moment-timezone';

function normalizer(data, state = null) {
    const output                 = Object.assign({}, data);
        output.store_id        = parseInt(output.store_id, 10);
        output.publish_date    = output.publish_date ? moment(output.publish_date).tz('Asia/Tehran').format('YYYY-MM-DD HH:mm:ss') : null;
        output.expiration_date = moment(output.expiration_date).tz('Asia/Tehran').format('YYYY-MM-DD HH:mm:ss');

    output.is_limited = output.is_limited && output.expiration_date ? output.is_limited : 0;
    output.expiration_date = output.expiration_date ? (output.is_limited ? output.expiration_date : null) : null;
    output.verified = output.verified ? 1 : 0;
    output.meta_title = output.meta_title ? output.meta_title :  null;
    output.code = output.code ? output.code : '';
    output.plan = output.plan ? 1 : 0;

    output.upload = null;

    return output;
}

function prepareForEdit(data) {
    // tags
    if(data.tag !== undefined && data.tag !== []) {
        data.tag = data.tag.map(t => {return {key: t.id, label: t.title}});
    }

    return data;
}

export {
    normalizer,
    prepareForEdit
}



// WEBPACK FOOTER //
// ./src/containers/Jobs/pipeline.js